enum InputAttribute {
  TransactionRef = 1,
  TransactionType = 2,
  TransactionAmount = 3,
  MaskedPAN = 5,
  CardExpiryDate = 6,
  CNP = 12,
  PGTR = 13,
  TransactionKeyed = 18,
  TokenReference = 19,
  CashTenderAmount = 20,
  RemoveCard = 25,
  GoOnline = 26,
  CashTransaction = 28,
  AuthorisationCode = 30,
  NewdayDiscountCode = 72,
  TransactionPurpose = 103,
  SendAttempt = 108,
  Quantity = 109,
  TransactionName = 110,
  PaymentInstrumentIdentifier = 111
}

export default InputAttribute;
